<template>
  <v-card
    class="elevation-0 transparent"
    shaped
    :id="setDikrID(subDikr.ID)"
    :light="!$vuetify.theme.dark"
    :dark="$vuetify.theme.dark"
  >
    <v-card-title class="mb-4">
      <v-spacer></v-spacer>
      <template v-for="(btn, b) in subDikr.actions">
        <v-tooltip :key="b" top>
          <template v-if="btn.render" v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              fab
              class="mx-2"
              @click="btn.cb(subDikr)"
              v-bind="attrs"
              v-on="on"
              color="primary"
              meduim
            >
              <v-icon dark small>
                <template v-if="btn.icons.length === 2">
                  {{ btn.active ? btn.icons[0] : btn.icons[1] }}
                </template>
                <template v-else>
                  {{ btn.icons[0] }}
                </template>
              </v-icon>
            </v-btn>
          </template>
          <span class="text-capitalize">{{ btn.tooltip }}</span>
        </v-tooltip>
      </template>
    </v-card-title>
    <v-card-text class="font-weight-bold text-center pa-0">
      {{ subDikr.ARABIC_TEXT }}
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    subDikr: {
      type: Object,
      require: true,
    },
  },
  methods: {
    setDikrID(id) {
      return "doa2-" + (id + 1);
    },
  },
};
</script>
